"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InputLabel = function InputLabel(_ref) {
  var inputId = _ref.inputId,
      inputUniqueId = _ref.inputUniqueId,
      isDisabled = _ref.isDisabled,
      isValid = _ref.isValid,
      label = _ref.label,
      labelId = _ref.labelId,
      labelUniqueId = _ref.labelUniqueId,
      type = _ref.type;
  var isCheckbox = type === 'checkbox';
  var isRadio = type === 'radio';
  var labelStyles = (0, _classnames.default)('form-control__label', {
    'form-control__label--error': !isValid && (isCheckbox || isRadio),
    'form-control__label--radio': isRadio,
    'form-control__label--disabled': isDisabled
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "form-control__label-wrapper",
    "data-testid": "inputLabel"
  }, /*#__PURE__*/_react.default.createElement("label", {
    id: labelId || labelUniqueId,
    htmlFor: inputId || inputUniqueId,
    className: labelStyles,
    "data-testid": "inputLabel-label-".concat(labelId || inputUniqueId)
  }, label));
};

InputLabel.propTypes = {
  /**
   Optional. Manually set in the parent.
   */
  inputId: _propTypes.default.string,

  /**
   Optional. Generated and set in the parent.
   */
  inputUniqueId: _propTypes.default.string,

  /**
   Optional. Determines how the label is styled when the input is disabled.
   */
  isDisabled: _propTypes.default.bool,

  /**
   Optional. Determines how the label is styled when the input is has errors.
   */
  isValid: _propTypes.default.bool,

  /**
   Required. Label, passed through.
   */
  label: _propTypes.default.string.isRequired,

  /**
   Optional. Manually set in the parent.
   */
  labelId: _propTypes.default.string,

  /**
   Optional. Generated and set in the parent.
   */
  labelUniqueId: _propTypes.default.string,

  /**
   Optional. Input type options: 'checkbox', 'email', 'password', 'radio', 'tel', 'text'. Defaults to 'text'
   */
  type: _propTypes.default.oneOf(['checkbox', 'email', 'password', 'radio', 'tel', 'text'])
};
InputLabel.defaultProps = {
  inputId: '',
  inputUniqueId: '',
  isDisabled: false,
  isValid: true,
  labelId: '',
  labelUniqueId: '',
  type: 'text'
};
var _default = InputLabel;
exports.default = _default;